// extracted by mini-css-extract-plugin
module.exports = {"Container":"Pause_Container__3pI0-","PauseContainer":"Pause_PauseContainer__1yqDb","Title":"Pause_Title__ahk9P","ButtonsContainer":"Pause_ButtonsContainer__3VWhm"};